// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tKJOy","left":"styles_left__2JheG","right":"styles_right__1S0_Q","alert":"styles_alert__1KFl0"};